import { t } from 'i18next'

import * as yup from 'yup'

import { IFormModel } from 'types'

/**
 * Form constants
 */
const TITLE = 'title'
const ACADEMIC_YEAR = 'academic_year'
const START_DATE = 'start_date'
const END_DATE = 'end_date'

/**
 * Form model
 */
const formModel = (): IFormModel => {
  return {
    [TITLE]: {
      label: `${t('common.title')}`,
      name: TITLE,
      required: true,
    },
    [ACADEMIC_YEAR]: {
      label: `${t('school.academic-year')}`,
      name: ACADEMIC_YEAR,
      required: true,
    },
    [START_DATE]: {
      label: `${t('common.start-date')}`,
      name: START_DATE,
      required: true,
    },
    [END_DATE]: {
      label: `${t('common.end-date')}`,
      name: END_DATE,
      required: true,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [TITLE]: '',
  [ACADEMIC_YEAR]: new Date().getFullYear(),
  [START_DATE]: null,
  [END_DATE]: null,
}

/**
 * Form data validation
 */
export const validationSchema = () =>
  yup.object().shape({
    [TITLE]: yup.string().required(`${t('errors.required-error-message')}`),
    [ACADEMIC_YEAR]: yup.number().required(`${t('errors.required-error-message')}`),
    [START_DATE]: yup
      .date()
      .required(`${t('errors.required-error-message')}`)
      .typeError('errors.invalid-date-message'),
    [END_DATE]: yup
      .date()
      .required(`${t('errors.required-error-message')}`)
      .typeError('errors.invalid-date-message'),
  })

export default formModel
